import { handleAction, combineActions } from 'redux-actions';

import allActions from '../actions/allActions';
import { logoutAction } from '../actions/authentication';

const initialState = [];

export const isError = action => (
  action.error || (action.meta && action.meta.error) || action.payload instanceof Error);

export const defaultErrorHandler = (state, action) => {
  // eslint-disable-next-line no-console
  console.error(action.payload);
  return state;
};

export const errorReducer = (state, action) => {
  if (action.type === logoutAction.toString()) {
    // User changed, clean all data!
    return initialState;
  }
  return isError(action)
    ? state.concat([action.payload])
    : state;
};

export default handleAction(combineActions(...allActions), {
  next: errorReducer,
  throw: defaultErrorHandler,
}, initialState);
